import React, { useContext, useEffect, useState } from "react";
import { Form, Media } from "react-bootstrap";
import Layout from "../../components/Layout";
import { callAPI } from "../../helper/apiUtils";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import { BASE_URL } from "../../helper/constants";
import { Link } from "react-router-dom";
import { $crud } from "../../helper/CrudFactory";
import _ from "lodash";
import { convertBranchRole } from "../../helper/convertor";
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import "./Followers.css";
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};
const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);
function Followers() {
  const { isGerm, strings } = useContext(LanguageContext);
  const [followers, setFollowers] = useState([]);
  const [allFollowers, setAllFollowers] = useState([])
  const [search, setSearch] = useState("")
  const [isLoading, setIsLoading] = useState(true);
  const [isContentReady, setIsContentReady] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const getFollowers = async () => {
    setIsLoading(true);
    setIsContentReady(false);
    setShowSkeleton(true);
    try {
      const { data } = await callAPI(`/user/follower`, {}, "GET");
      const followersList = _.sortBy(data.followers || [], [
        (follower) => follower?.lastName?.toLowerCase(),
      ]);
      setAllFollowers([...followersList])
      setFollowers([...followersList]);
    } catch (error) {
      console.error('Error loading followers:', error);
      setFollowers([]);
      setAllFollowers([]);
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        setShowSkeleton(false);
      }, 300);
      setTimeout(() => {
        setIsContentReady(true);
      }, 400);
    }
  };
  useEffect(() => {
    getFollowers();
  }, []);

  const removeFollower = async (follower) => {
    const message = (strings.remove_follower_confirm || "Do you really want to remove {name} from following you? If you remove him/her he/she will not get informed.").replace("{name}", follower.fullName || "");
    await $crud.confirm({
      title: "",
      textContent: message,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    const { data } = await callAPI(`/user/${follower.id}/remove`, {}, "GET");
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    await getFollowers();
  };
  const searchFollowers = async (value) => {
    setSearch(value);
    value = value.trim();
    const searchResult = await allFollowers.filter((itm) => {
      if (!itm.isCompany && (itm.firstName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.lastName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.fullName?.toLowerCase().startsWith(value?.toLowerCase()))) {
        return true
      }
      // if (value === "") {
      //   return itm;
      // } else if (itm.firstName?.toLowerCase().startsWith(value?.toLowerCase()) || itm.lastName?.toLowerCase().startsWith(value?.toLowerCase())) {
      //   return itm;
      // }
    });
    if (value === "") {
      setFollowers(allFollowers);
    } else {
      setFollowers(searchResult);
    }
  };

  const isDesktopResolution = useSelector(state => state.isDesktopResolution)

  return (
    <React.Fragment>
      {isLoading || showSkeleton ? (
        <div className={`following follower loading followers followers--skeleton${showSkeleton ? ' followers--skeleton-active' : ''} ${!showSkeleton ? 'skeleton-fade-out' : ''}`}>
          {/* Skeleton Header */}
          <div className="main_heading followers__heading">
            <div className="skeleton skeleton-icon followers__sk-icon"></div>
            <div className="skeleton skeleton-text followers__sk-title"></div>
          </div>
          {/* Skeleton Search */}
          <div className="search followers__search">
            <div className="skeleton followers__sk-search"></div>
          </div>
          {/* Skeleton List Items */}
          <div className="my-scroll contact_height followers__scroll">
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="post_notification followers__sk-item">
                <div className="my_post followers__sk-row">
                  <div className="skeleton skeleton-image followers__sk-avatar"></div>
                  <div className="kj-flex-1">
                    <div className="skeleton skeleton-text followers__sk-line"></div>
                    <div className="skeleton skeleton-text short followers__sk-line-short"></div>
                  </div>
                  <div className="skeleton followers__sk-button"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={`following follower loaded followers followers--content ${isContentReady ? 'company-content-fade-in' : ''}`}>
          <div className="main_heading followers__heading followers__heading--content">
            <Link to="/profile">
              <span className="material-symbols-outlined material-arrow-left">
                keyboard_arrow_left
              </span>
            </Link>
            {strings.followers}
          </div>
          <div className="search followers__search">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                autocomplete="off"
                onChange={(e) => searchFollowers(e.target.value)}
                value={search}
                type="search"
                placeholder={strings.search}
              />
            </Form.Group>
          </div>
          <div className="my-scroll contact_height followers__scroll">
            <CustomScrollbars
              autoHide
              autoHideTimeout={500}
              autoHideDuration={200}
              className="bottom-bar"
            >
              {followers && followers.length > 0 ? (
                followers.map((follower, index) => (
                  <div key={follower.id} className="post_notification followers__item" style={{ '--followers-item-delay': `${index * 0.05}s` }}>
                    <div className="my_post">
                      <Media>
                        <img
                          width={30}
                          height={30}
                          className={`mr-3 followers__avatar${(follower.isKjuup || follower.companies?.some(c => c.isKjuup)) ? ' followers__avatar--internal' : ''}`}
                          src={
                            follower.avatar
                              ? BASE_URL + follower.avatar
                              : process.env.PUBLIC_URL + "/assets/img/head.svg"
                          }
                          alt="Generic placeholder"
                          onLoad={(e) => {
                            if (e.target) e.target.style.opacity = '1';
                          }}
                        />
                        <Media.Body>
                          <div className="authore_name">
                            <Link to={`/user-profile/${follower.id}`}>
                              <h5>{follower.fullName}</h5>
                            </Link>
                            <p className="followers__role">{convertBranchRole(follower.buildingIndustryRole, isGerm)}</p>
                          </div>
                        </Media.Body>
                        <button
                          type="button"
                          className="kj-btn kj-btn--outline kj-btn--on-surface kj-btn--sm"
                          onClick={(e) => {
                            e.preventDefault();
                            removeFollower(follower);
                          }}
                        >
                          {" "}
                          {strings.remove}
                        </button>
                      </Media>
                    </div>
                  </div>
                ))
              ) : (
                <div className="followers__empty">
                  {isGerm ? 'Keine Abonnenten gefunden' : 'No followers found'}
                </div>
              )}
            </CustomScrollbars>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Followers;
